import { AuthorizedUserPermission } from '@api/services/authorized-user/types';
import Icon from '@components/icon/Icon';
import { mdiPencil as writeIcon, mdiEye as readIcon, mdiWrench as ownerIcon } from '@mdi/js';
import './requestPermissionDisplay.scss';

const iconPaths = {
  Read: readIcon,
  Write: writeIcon,
  Owner: ownerIcon,
};

const labelTexts = {
  Read: 'Read-Only Access',
  Write: 'Write Access',
  Owner: 'Owner Access',
};

const titleTexts = {
  Read: 'You have read-only access to this request',
  Write: 'You have write access to this request',
  Owner: 'You are the owner of this request',
};

type RequestPermissionDisplayProps = {
  permission: AuthorizedUserPermission;
};

const RequestPermissionDisplay = ({ permission }: RequestPermissionDisplayProps) => {
  return (
    <div className={`permission-display ${permission.toLowerCase()}`} title={titleTexts[permission]}>
      <Icon focusable={false} path={iconPaths[permission]} />
      {labelTexts[permission]}
    </div>
  );
};

export default RequestPermissionDisplay;
